import React, { useState, useEffect } from "react";
import "./App.css";
import {
  Routes,
  Route,
  BrowserRouter,
  useLocation,
  Navigate,
} from "react-router-dom";
import Signup from "./components/signup/signup";
import OTP from "./components/otp/otp";
import Login from "./components/login/login";
import Verify from "./components/verify/verify";
import AddPatient from "./components/add-patient/add-patient";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import MedicalIntake from "./components/medical-intake/medical-intake";
import PatientRequisition from "./components/patient-requisition-form/patient-requisition";
import ReviewTestOrder from "./components/review-test-order/review-test-order";
import OrderSuccess from "./components/order-success/order-success";
import UploadRequisitionForm from "./components/upload-requisition-form/upload-requisition-form";
import OrderDetails from "./components/order-details/order-details";
import ContactSupport from "./components/contact-support/contact-support";
import ResetPassword from "./components/reset-password/reset-password";
import EditProfile from "./components/edit-profile/edit-profile";
import Dashboard from "./components/dashboard/dashboard";
import OrderATest from "./components/order-a-test/order-a-test";
import MyOrders from "./components/my-orders/my-orders";
import ManagePatients from "./components/manage-patients/manage-patients";
import HelpAndSupport from "./components/help-and-support/help-and-support";
import Resources from "./components/resources/resources";
import PatientDetails from "./components/patient-details/patient-details";
import ContactForm from "./components/contact-form/contact-form";
import NotFound from "./components/not-found/not-found";
import TestDetails from "./components/test-details/test-details";
import Sidebar from "./components/sidebar/sidebar";
import Header from "./components/header/header";
import Nav from "./components/nav/nav";
import VerificationStatus from "./components/verification-status/verification-status";
import NewPassword from "./components/new-password/new-password";
import ForgotPassword from "./components/forgot-password/forgot-password";
import { GlobalProvider, GlobalContext } from "./GlobalContext";
import Tiles from "./components/tiles/tiles";
import PartnerLabs from "./components/partner-labs/partner-labs";
import Homepage from "./components/homepage/homepage";
import GeneticCounselors from "./components/genetic-counselors/genetic-counselors";
import CounselorDetails from "./components/counselor-details/counselor-details";
import TalkToSpecialist from "./components/talk-to-specialist/talk-to-specialist";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PublicRoute from "./components/auth/PublicRoute";

const Layout = ({ children }) => {
  const location = useLocation();
  const { updateNavigationHistory } = React.useContext(GlobalContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Update navigation history on route change
    updateNavigationHistory(location.pathname, location.search);
  }, [location.pathname, location.search, updateNavigationHistory]);

  // Define page titles for each route
  const pageTitles = {
    "/": "Home - Direct by Syndicate Bio",
    "/register": "Sign Up - Direct by Syndicate Bio",
    "/otp": "OTP Verification - Direct by Syndicate Bio",
    "/login": "Login - Direct by Syndicate Bio",
    "/verify": "Verify Account - Direct by Syndicate Bio",
    "/forgot-password": "Forgot Password - Direct by Syndicate Bio",
    "/new-password": "Set New Password - Direct by Syndicate Bio",
    "/dashboard": "Dashboard - Direct by Syndicate Bio",
    "/order-a-test": "Order a Test - Direct by Syndicate Bio",
    "/my-orders": "My Orders - Direct by Syndicate Bio",
    "/manage-patients": "Manage Patients - Direct by Syndicate Bio",
    "/help-and-support": "Help and Support - Direct by Syndicate Bio",
    "/profile": "Edit Profile - Direct by Syndicate Bio",
    "/resources": "Resources - Direct by Syndicate Bio",
    "/add-patient": "Add Patient - Direct by Syndicate Bio",
    "/medical-intake-form": "Medical Intake Form - Direct by Syndicate Bio",
    "/order-test": "Patient Requisition - Direct by Syndicate Bio",
    "/review-test-order": "Review Test Order - Direct by Syndicate Bio",
    "/order-success": "Order Success - Direct by Syndicate Bio",
    "/contact-support": "Contact Support - Direct by Syndicate Bio",
    "/reset-password": "Reset Password - Direct by Syndicate Bio",
    "/contact-form": "Contact Form - Direct by Syndicate Bio",
    "/verification-status": "Verification Status - Direct by Syndicate Bio",
    "/medical-test/:test_slug": "Test Details - Direct by Syndicate Bio",
    "/my-order/:order_id": "Order Details - Direct by Syndicate Bio",
    "/patient-details/:patient_id": "Patient Details - Direct by Syndicate Bio",
    "/partner-labs": "Our Partner Labs - Direct by Syndicate Bio",
    "/genetic-counselors": "Our Genetic Counselors - Direct by Syndicate Bio",
    "/counselor-details/:counselor_id": "Counselor Details - Direct by Syndicate Bio",
    "*": "Not Found - Direct by Syndicate Bio",
  };

useEffect(() => {
  const normalizedPathname = location.pathname.replace(/\/+$/, "") || "/";
  console.log("Pathname:", location.pathname, "Normalized:", normalizedPathname);

  let title = pageTitles[normalizedPathname] || pageTitles["*"];

  if (normalizedPathname.startsWith("/medical-test/")) {
    title = pageTitles["/medical-test/:test_slug"];
  } else if (normalizedPathname.startsWith("/my-order/")) {
    title = pageTitles["/my-order/:order_id"];
  } else if (normalizedPathname.startsWith("/patient-details/")) {
    title = pageTitles["/patient-details/:patient_id"];
  } else if (normalizedPathname.startsWith("/counselor-details/")) {
    title = pageTitles["/counselor-details/:counselor_id"];
  }

  console.log("Setting title to:", title); // Debug log
  document.title = title;
}, [location]);


  const normalizedPathname =
    location.pathname === "/" ? "/" : location.pathname.replace(/\/+$/, "");
const hideSidebarAndHeader =
  [
    "/",
    "/register",
    "/otp",
    "/login",
    "/verify",
    "/order-success",
    "/new-password",
    "/forgot-password",
    "/genetic-counselors",
  ].includes(normalizedPathname) ||
  normalizedPathname.startsWith("/counselor-details/");


  const shouldShowNav = () => {
    const navPaths = [
      "/add-patient",
      "/medical-intake-form",
      "/review-test-order",
      "/talk-to-specialist",
      "/my-orders",
      "/my-order",
      "/contact-support",
      "/reset-password",
      "/patient-details",
      "/contact-form",
      "/order-test",
      "/medical-test",
      "/partner-labs",
    ];
    return navPaths.some(
      (navPath) =>
        normalizedPathname === navPath ||
        normalizedPathname.startsWith(`${navPath}/`)
    );
  };

  const showNav = shouldShowNav();

  return (
    <div style={{ display: "flex" }}>
      {!hideSidebarAndHeader && <Sidebar />}
      <div
        style={{
          flex: 1,
          paddingLeft: hideSidebarAndHeader || isMobile ? 0 : 250,
          paddingTop: hideSidebarAndHeader ? 0 : 75,
          backgroundColor: hideSidebarAndHeader || isMobile ? "#ffffff" : "#faf9fb",
        }}
      >
        {!hideSidebarAndHeader && <Header />}
        {showNav && <Nav />}
        <main>{children}</main>
      </div>
    </div>
  );
};

function App() {
  return (
    <MantineProvider>
      <BrowserRouter>
        <GlobalProvider>
          <Layout>
            <Routes>
              {/* Public routes - accessible without authentication */}
              <Route path="/" element={<Homepage />} />
              <Route path="/genetic-counselors" element={<GeneticCounselors />} />
              <Route path="/counselor-details/:counselor_id" element={<CounselorDetails />} />

              {/* Authentication routes - redirect to dashboard if already authenticated */}
              <Route path="/register" element={
                <PublicRoute>
                  <Signup />
                </PublicRoute>
              } />
              <Route path="/otp" element={
                <PublicRoute>
                  <OTP />
                </PublicRoute>
              } />
              <Route path="/login" element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } />
              <Route path="/forgot-password" element={
                <PublicRoute>
                  <ForgotPassword />
                </PublicRoute>
              } />
              <Route path="/new-password" element={
                <PublicRoute>
                  <NewPassword />
                </PublicRoute>
              } />

              {/* Protected routes - require authentication */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/order-a-test" element={
                <ProtectedRoute>
                  <OrderATest />
                </ProtectedRoute>
              } />
              <Route path="/my-orders" element={
                <ProtectedRoute>
                  <MyOrders />
                </ProtectedRoute>
              } />
              <Route path="/manage-patients" element={
                <ProtectedRoute>
                  <ManagePatients />
                </ProtectedRoute>
              } />
              <Route path="/help-and-support" element={
                <ProtectedRoute>
                  <HelpAndSupport />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <EditProfile />
                </ProtectedRoute>
              } />
              <Route path="/resources" element={
                <ProtectedRoute>
                  <Resources />
                </ProtectedRoute>
              } />
              <Route path="/add-patient" element={
                <ProtectedRoute>
                  <AddPatient />
                </ProtectedRoute>
              } />
              <Route path="/medical-intake-form" element={
                <ProtectedRoute>
                  <MedicalIntake />
                </ProtectedRoute>
              } />
              <Route path="/order-test" element={
                <ProtectedRoute>
                  <PatientRequisition />
                </ProtectedRoute>
              } />
              <Route path="/review-test-order" element={
                <ProtectedRoute>
                  <ReviewTestOrder />
                </ProtectedRoute>
              } />
              <Route path="/medical-test/:test_slug" element={
                <ProtectedRoute>
                  <TestDetails />
                </ProtectedRoute>
              } />
              <Route path="/my-order/:order_id" element={
                <ProtectedRoute>
                  <OrderDetails />
                </ProtectedRoute>
              } />
              <Route path="/contact-support" element={
                <ProtectedRoute>
                  <ContactSupport />
                </ProtectedRoute>
              } />
              <Route path="/reset-password" element={
                <ProtectedRoute>
                  <ResetPassword />
                </ProtectedRoute>
              } />
              <Route path="/patient-details/:patient_id" element={
                <ProtectedRoute>
                  <PatientDetails />
                </ProtectedRoute>
              } />
              <Route path="/contact-form" element={
                <ProtectedRoute>
                  <ContactForm />
                </ProtectedRoute>
              } />
              <Route path="/order-success" element={
                <ProtectedRoute>
                  <OrderSuccess />
                </ProtectedRoute>
              } />
              <Route path="/verification-status" element={
                <ProtectedRoute>
                  <VerificationStatus />
                </ProtectedRoute>
              } />
              <Route path="/verify" element={
                <ProtectedRoute>
                  <Verify />
                </ProtectedRoute>
              } />
              <Route path="/partner-labs" element={
                <ProtectedRoute>
                  <PartnerLabs />
                </ProtectedRoute>
              } />
              <Route path="/talk-to-specialist" element={
                <ProtectedRoute>
                  <TalkToSpecialist />
                </ProtectedRoute>
              } />

              {/* Catch-all route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </GlobalProvider>
      </BrowserRouter>
    </MantineProvider>
  );
}

export default App;
